//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BORDERS } from "@/constants/ui.js";

export default {
  name: "BorderChoice",

  props: {
    line: {
      type: String,
      default: 'solid'
    }
  },
  emits: ['update:line'],
  computed: {
    borders() {
      return BORDERS
    },
  }
}
